import React from 'react';
import { StyleSheet, View, Platform } from 'react-native';
import { useNavigation } from '@react-navigation/native';
import colors from '../../../config/colors';
import I18n from '../../../components/shared/i18n/I18n.component';
import ActionButton from '../../../components/shared/Buttons/ActionButton.container';
import ImageIcon from '../../../components/shared/Icon/ImageIcon.component';
import { convertDateToLocal } from '../../../utils/convertDateToLocal.utils';
import {
	EventName,
	logEvent,
} from '../../../services/analyticsAndLogs.service';

type PaycheckCardProps = {
	reportDateYear: string;
};

export const monthsMapFilter: Record<number, string> = {
	1: 'ינואר',
	2: 'פברואר',
	3: 'מרץ',
	4: 'אפריל',
	5: 'מאי',
	6: 'יוני',
	7: 'יולי',
	8: 'אוגוסט',
	9: 'ספטמבר',
	10: 'אוקטובר',
	11: 'נובמבר',
	12: 'דצמבר',
};

const PaycheckCard = ({ reportDateYear }: PaycheckCardProps) => {
	const navigation = useNavigation();

	const localDate = reportDateYear ? convertDateToLocal(reportDateYear) : null;
	const monthName = localDate ? monthsMapFilter[localDate.month() + 1] : undefined;
	const year = localDate ? localDate.year() : undefined;
	const paycheckTitleKey = reportDateYear
		? 'reportView.wageDataSummary.paycheckCardTitleReady'
		: 'reportView.wageDataSummary.paycheckCardTitleDefault';

	return (
		<View style={styles.card}>
			<View style={styles.textContainer}>
				<I18n
					size={14}
					font={'medium'}
					color={'primaryDarkBlue'}
					monthName={monthName}
					year={year}
				>
					{paycheckTitleKey}
				</I18n>
				<I18n size={14} weight={'400'} color={'greyText'}>
					reportView.wageDataSummary.paycheckCardSubtitle
				</I18n>
			</View>
			<View style={styles.row}>
				<ActionButton
					onPress={() => {
						logEvent({
							eventName: EventName.reportSalaryButton,
							data: {},
						});
						navigation.navigate('paycheck', {
							screen: 'employee',
						});
					}}
				>
					<ImageIcon name={'chevronLeft'} />
					<I18n size={15} weight={'400'} color={'primary'}>
						reportView.wageDataSummary.paycheckCardButton
					</I18n>
				</ActionButton>
			</View>
		</View>
	);
};

const styles = StyleSheet.create({
	card: {
		flex: 1,
		backgroundColor: colors.white,
		borderRadius: 8,
		padding: 24,
		justifyContent: 'center',
		...Platform.select({
			web: { gap: 16, boxShadow: '2px 2px 16px 0 rgba(0, 0, 0, 0.04)' },
			ios: { shadowColor: '#000', shadowOffset: { width: 2, height: 2 }, shadowOpacity: 0.04, shadowRadius: 16 },
			android: { elevation: 2 },
		}),
	},
	row: {
		flexDirection: 'row-reverse',
		flexWrap: 'wrap',
		alignItems: 'center',
	},
	textContainer: {
		flexDirection: 'column',
		alignItems: 'flex-end',
		...Platform.select({ web: { gap: 8 }, native: { marginBottom: 16 } }),
	},
});

export default PaycheckCard;
